var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResetModal',{attrs:{"header":"You are about to Mend the Multiverse","message":_vm.message,"gained-resources":_vm.gainedResources,"confirm-fn":_vm.handleYesClick}})}
var staticRenderFns = []

export { render, staticRenderFns }